import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetFaultModesDropdownListQuery } from '../../api/endpoints/compound';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Fault Modes dropdown component with search functionality
 * @param {Object} props
 * @param {number|Object} props.value - The selected value (id)
 * @param {Function} props.onChange - Callback when selection changes
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Whether the dropdown is disabled
 * @param {string} props.placeholder - Placeholder text
 */
const FaultModesDropdown = ({ value, onChange, className = '', disabled = false, placeholder = 'Hata modu seçiniz veya arayınız' }) => {
    const { getCurrentLanguageId } = useLanguage();
    const [selectedFaultMode, setSelectedFaultMode] = useState(null);
    const [searchText, setSearchText] = useState('');

    // API'den listeyi çek
    const languageId = getCurrentLanguageId();
    
    const { data: faultModesList = [], isLoading } = useGetFaultModesDropdownListQuery({
        languageId: languageId
    });

    // Dropdown için liste (sadece text ve id)
    const faultModesOptions = faultModesList
        .filter((mode) => mode.text.toLowerCase().includes(searchText.toLowerCase()))
        .map((mode) => ({
            id: mode.id,
            text: mode.text
        }));

    // Seçim değişince
    const handleSelectionChange = (e) => {
        setSelectedFaultMode(e.value);
        onChange(e.value ? e.value.id : null); // Sadece id gönder
    };

    // Filtre değişince
    const handleFilterChange = (e) => {
        setSearchText(e.filter);
    };

    // İlk değer ayarla
    useEffect(() => {
        if (value && faultModesOptions.length > 0 && !selectedFaultMode) {
            const found = faultModesOptions.find((option) => option.id.toString() === value.toString());
            if (found) {
                setSelectedFaultMode(found);
            }
        }
    }, [value, faultModesOptions, selectedFaultMode]);

    return (
        <Dropdown
            value={selectedFaultMode}
            options={faultModesOptions}
            onChange={handleSelectionChange}
            onFilter={handleFilterChange}
            optionLabel="text" // EKRANDA SADECE TEXT GÖZÜKÜR
            filter
            showClear
            filterBy="text"
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            virtualScrollerOptions={{ itemSize: 38 }}
        />
    );
};

export default FaultModesDropdown;
